import { useEffect, useState } from "react";
import api from "@/lib/api";
import { UNDERSTANDING } from "@/lib/format";
import { Label } from "@/components/ui/label";
import { History, Star } from "lucide-react";

export function UnderstandingPicker({ value, onChange }) {
  return (
    <div className="flex gap-2 flex-wrap">
      {Object.entries(UNDERSTANDING).map(([k, v]) => (
        <button key={k} type="button" data-testid={`understanding-${k}`} onClick={() => onChange(k)}
          className={`px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors ${value === k ? v.cls + " ring-2 ring-offset-1" : "bg-white text-slate-500 border-slate-200 hover:border-orange-300"}`}>
          {v.label}
        </button>
      ))}
    </div>
  );
}

export function MaterialHistory({ studentId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!studentId) { setItems(null); return; }
    api.get("/journals", { params: { student_id: studentId } }).then((r) => setItems(r.data));
  }, [studentId]);
  if (!studentId) return null;
  return (
    <div className="rounded-xl bg-slate-50 border border-slate-100 p-3" data-testid="material-history">
      <Label className="flex items-center gap-1 text-xs text-slate-500 mb-2"><History className="w-3.5 h-3.5" /> Riwayat materi ({items?.length ?? 0})</Label>
      {!items ? null : items.length === 0 ? <p className="text-xs text-slate-400">Belum ada materi yang diajarkan.</p> : (
        <div className="max-h-32 overflow-y-auto gemma-scroll space-y-1">
          {items.slice(0, 20).map((j) => (
            <div key={j.id} className="flex items-center gap-2 text-xs">
              <span className="text-slate-400 w-16 shrink-0">{j.date.slice(5).split("-").reverse().join("/")}</span>
              <span className="text-slate-700 truncate flex-1">{j.material}</span>
              <span className={`px-1.5 py-0.5 rounded-full text-[10px] border ${UNDERSTANDING[j.understanding || "paham"].cls}`}>{UNDERSTANDING[j.understanding || "paham"].label}</span>
              <span className="text-amber-500 flex items-center gap-0.5 shrink-0"><Star className="w-3 h-3 fill-amber-400" />{j.rating}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
